module.exports = __webpack_public_path__ + "img/thumb_Atelier_3.7438baa7.jpg";